import React from 'react'
import { Provider } from 'react-redux'
import UpdateWidget from './src/components/updateWidget/updateWidget'
import ForwardingWidget from './src/components/forwardingWidget/forwardingWidget'
import createStore from './src/state/createStore'
import { Crisp } from "crisp-sdk-web";

import { Initialize } from 'ipfs-public-fetcher'
let initialized = false

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,react/display-name,react/prop-types
export default ({ element }) => {

  const store = createStore()
  if (!initialized) {
    // Initializing CRISP
    Crisp.configure(process.env.GATSBY_CRISP_WEBSITE_ID);
    // Initializing IPFS Public Fetcher
    Initialize({
      customDomains: [
        "https://otoco-production.infura-ipfs.io/ipfs/:hash",
        // "https://ipfs.io/ipfs/:hash",
        "https://cf-ipfs.com/ipfs/:hash",
        // "https://dweb.link/ipfs/:hash",
        // "https://ipfs-gateway.cloud/ipfs/:hash",
        // "https://w3s.link/ipfs/:hash",
        "https://cloudflare-ipfs.com/ipfs/:hash",
        // "https://nftstorage.link/ipfs/:hash",
        // "https://api.estuary.tech/gw/ipfs/:hash",
        "https://ipfs.eth.aragon.network/ipfs/:hash",
        "https://gateway.pinata.cloud/ipfs/:hash",
      ]
    })
    initialized = true
  }


  return <Provider store={store}>
    <>
      <UpdateWidget />
      <ForwardingWidget />
      {element}
    </>
  </Provider>
}
